import { render } from "./Index.vue?vue&type=template&id=cd7836da&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=cd7836da&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=cd7836da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cd7836da"

export default script